import React, { useEffect, useRef, useState } from "react";
import "./landing.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { js } from "js-beautify";
import { auth } from "../../config";
import { signOut, onAuthStateChanged } from "firebase/auth";

const data = [
  {
    chat: "Hello,i’m fine,how can i help you?",
  },
  {
    chat: "There are many programming languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
  {
    chat: "Languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
  {
    chat: "Hello,i’m fine,how can i help you?",
  },
  {
    chat: "There are many programming languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
  {
    chat: "Languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
  {
    chat: "Hello,i’m fine,how can i help you?",
  },
  {
    chat: "There are many programming languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
  {
    chat: "Languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
  {
    chat: "Hello,i’m fine,how can i help you?",
  },
  {
    chat: "There are many programming languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
  {
    chat: "Languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
  {
    chat: "Hello,i’m fine,how can i help you?",
  },
  {
    chat: "There are many programming languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
  {
    chat: "Languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are popular in their place and in the way they are used, and many programmers learn and use them.",
  },
];
function Landing({ currentUser }) {
  const [isLeftDivVisible, setIsLeftDivVisible] = useState(true);
  const [textArea, setTextArea] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState(false);

  const useNav = useNavigate();

  const chatRef = useRef();

  const handleFilterBtnClick = () => {
    setIsLeftDivVisible((prev) => !prev);
  };
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    } else {
      return text.substring(0, maxLength) + "...";
    }
  };
  const textAreaRef = useRef();

  useEffect(() => {
    if (textAreaRef.current) {
      console.log("d", textAreaRef.current.scrollHeight);

      textAreaRef.current.style.height = "22px";
      const scrollHeight = textAreaRef.current.scrollHeight;
      textAreaRef.current.style.height = scrollHeight + "px";
    }
  }, [textArea]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsLeftDivVisible(false);
      } else {
        setIsLeftDivVisible(true);
      }
    };

    handleResize(); // Initial check

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // Dropdown

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Modal
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [chatMessages, setChatMessages] = useState([]);

  useEffect(() => {
    chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [chatMessages]);

  const sendMessageToBot = () => {
    setChatMessages((prev) => [...prev, { type: "user", msg: textArea }]);
    setTextArea("");

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/chatbot`, { prompt: textArea })
      .then((res) => {
        console.log(res.data.answer);
        setChatMessages((prev) => [
          ...prev,
          { type: "bot", msg: res.data.answer },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
    chatRef.current.scrollTop = chatRef.current.scrollHeight;
  };
  const beautifyContent = (input) => {
    const options = {
      indent_size: 1,
      space_in_empty_paren: true,
      // add other options here
    };
    const beautifiedContent = js(input, options);
    // Trim leading and trailing whitespaces
    return beautifiedContent.trim();
  };
  const navigate = useNavigate();
  // For Protected Route

  // onAuthStateChanged(auth, (user) => {
  //   if (!user) {
  //     navigate("/login");
  //   }
  // else {
  //   setCurrentUser(auth.currentUser.displayName)
  // }

  // });

  function FormatString(value) {
    const unformattedString = value;

    // Split the unformatted string into paragraphs based on periods (.)
    const paragraphs = unformattedString.split(". ");

    // Remove empty paragraphs
    const filteredParagraphs = paragraphs.filter(
      (paragraph) => paragraph.trim() !== ""
    );

    // Join each paragraph with a period and a newline character
    const formattedText = filteredParagraphs.map((paragraph, index) => (
      <p key={index}>{paragraph.trim() + "."}</p>
    ));

    return <div>{formattedText}</div>;
  }

  return (
    <>
      <section className="main-sec">
        <div className="filter">
          <Icon
            className="filter-btn"
            icon="fluent:filter-24-filled"
            width="30"
            height="30"
            onClick={handleFilterBtnClick}
          />
        </div>
        {isLeftDivVisible && (
          <div className="asidebar">
            <div className="top">
              <div className="button-sec">
                <button className="newchat-btn">
                  <img src="/assets/images/newchat.svg" alt="..." />
                  New Chat
                </button>
                <div className="forHistoryBorder">
                  <div className="history-div">
                    <img src="/assets/images/history.svg" alt="..." />
                    <h3 className="heading-bold">History</h3>
                  </div>
                </div>
              </div>
              <div className="center">
                <h4 className="todayTitle">Today</h4>
                <div className="recent-chats">
                  {data.map((item, index) => (
                    <div className={`recentchat ${index == 0 ? "active" : ""}`}>
                      <div className="left">
                        {/* <img src="/assets/images/message.svg" alt="..." /> */}
                        <h4>{truncateText(item.chat, 22)}</h4>
                      </div>
                      <img src="/assets/images/delete.svg" alt="..." />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="forBorder">
              <div className="bottom" onClick={toggleDropdown}>
                <img src="/assets/images/profilenew.png" alt="..." />
                <h3 className="heading-light">
                  {currentUser ? currentUser : "Andrew"}
                </h3>
                {isOpen && (
                  <div className="dropdown-content">
                    {/* Your dropdown content goes here */}
                    {/* <p>
                    <Icon
                      icon="ic:outline-integration-instructions"
                      color="white"
                      width="20"
                      height="20"
                    />
                    Custom Instructions
                  </p> */}
                    {/* <p onClick={handleShow}>
                    <Icon
                      icon="uil:setting"
                      color="white"
                      width="20"
                      height="20"
                    />
                    Setting
                  </p> */}
                    {/* <Link to="/started"> */}
                    <p onClick={async () => await signOut(auth)}>
                      <Icon
                        icon="material-symbols:logout"
                        color="white"
                        width="20"
                        height="20"
                      />
                      Logout
                    </p>
                    {/* </Link> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="content">
          <div className="details">
            <div className="mainHEADING">
              {/* <img src="/assets/images/MADIS.png" alt="" />
              <h1 className="mandisAI">MADIS AI</h1> */}
              <img src="/assets/icon/logo.svg" alt="..." />
              <h1>CHAT</h1>
            </div>

            <div className="inner" ref={chatRef}>
              {chatMessages && chatMessages.length > 0 ? (
                chatMessages.map((item, index) => {
                  if (item.type == "user") {
                    return <div className="ist para-bold">{item.msg}</div>;
                  } else {
                    return (
                      <div className="second para-light">
                        {/* <div className="pre-wrap">  {FormatString(item.msg)}</div> */}
                        {/* <pre className="pre-wrap">  {(item.msg)}</pre> */}
                        {/* {item.msg} */}
                        {FormatString(item.msg)}
                      </div>
                    );
                  }
                })
              ) : (
                <></>
              )}
              {/* <div className="ist para-bold">
                Hello chatGPT, how are you today?
              </div>
              <div className="second para-light">
                Hello,i’m fine,how can i help you?
              </div>
              <div className="ist para-bold">
                What is the best programming language?
              </div>
              <div className="second para-light">
                There are many programming languages ​​in the market that are
                used in designing and building websites, various applications
                and other tasks. All these languages ​​are popular in their
                place and in the way they are used, and many programmers learn
                and use them.
              </div>
              <div className="ist para-bold">So explain to me more</div>
              <div className="second para-light">
                Languages ​​in the market that are used in designing and
                building websites, various applications and other tasks. All
                these languages ​​are popular in their place and in the way they
                are used, and many programmers learn and use them.
              </div>
              <div className="ist para-bold">
                Hello chatGPT, how are you today?
              </div>
              <div className="second para-light">
                Hello,i’m fine,how can i help you?
              </div>
              <div className="ist para-bold">
                What is the best programming language?
              </div>
              <div className="second para-light">
                There are many programming languages ​​in the market that are
                used in designing and building websites, various applications
                and other tasks. All these languages ​​are popular in their
                place and in the way they are used, and many programmers learn
                and use them.
              </div>
              <div className="ist para-bold">So explain to me more</div>
              <div className="second para-light">
                Languages ​​in the market that are used in designing and
                building websites, various applications and other tasks. All
                these languages ​​are popular in their place and in the way they
                are used, and many programmers learn and use them.
              </div> */}
            </div>

            <div className="input-sec">
              <label htmlFor="file">
                <img src="/assets/images/link.svg" alt="" />
              </label>
              <input type="file" name="" id="file" className="d-none" />
              <textarea
                placeholder="Send a message "
                ref={textAreaRef}
                value={textArea}
                onChange={(e) => {
                  setTextArea(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key == "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    sendMessageToBot();
                  }
                }}
              ></textarea>

              <img src="/assets/images/voice.svg" alt="" />
              <img
                className="micIcon"
                src="/assets/images/mic.png"
                alt=""
                onClick={sendMessageToBot}
              />
            </div>
          </div>
        </div>
      </section>
      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="setting-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Settings</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="setting-body">
          <div className="body-content">
            <div className="top">
              <div className="left">
                <h6>Chat history & training</h6>
                <p>
                  Save new chats on this browser to your history and allow them
                  to be used to improve our models. Unsaved chats will be
                  deleted from our systems within 30 days. This setting does not
                  sync across browsers or devices.{" "}
                  <span>
                    <a href="#">Learn more</a>
                  </span>
                </p>
              </div>
              <div className="right">
                <label class="switch">
                  <input type="checkbox" />
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div className="bottom">
              <div className="bottom-content">
                <h6>Shared links</h6>
                <button>Manage</button>
              </div>
              <div className="bottom-content">
                <h6>Export data</h6>
                <button>Export</button>
              </div>
              <div className="bottom-content">
                <h6>Delete account</h6>
                <button className="bg-danger">Delete</button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Landing;
